var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1161,
    height: 387,
    viewBox: "0 0 1161 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.783 0C184.71 0 134.288 30.8781 109.253 79.9266C98.7003 100.521 93.2331 123.343 93.3093 146.482V159.826H62.2603V186.405H93.3093V213.12H31.049V239.672H93.3093V266.386H0V292.938H93.3093V386.235H119.865V146.482C119.824 89.4826 159.94 40.3403 215.8 28.9609C255.265 20.9402 296.124 33.244 324.595 61.7229C353.067 90.2018 365.357 131.06 357.32 170.517C354.985 182.012 350.953 193.095 345.355 203.403C324.35 242.142 283.855 266.311 239.783 266.413H226.411V239.672H239.783C274.045 239.634 305.535 220.842 321.832 190.709C324.124 186.485 326.079 182.086 327.679 177.555C340.087 142.564 330.546 103.547 303.391 78.2284C276.235 52.9097 236.643 46.1165 202.599 60.9348C168.555 75.7531 146.551 109.357 146.582 146.482V386.235H173.246V146.482C173.263 119.97 188.998 95.9906 213.313 85.4175C237.629 74.8444 265.9 79.6896 285.306 97.7558C304.712 115.822 311.562 143.672 302.748 168.677C301.596 171.917 300.203 175.065 298.579 178.096C286.899 199.679 264.327 213.125 239.783 213.12H226.411V186.405H239.783C254.485 186.411 268.002 178.343 274.974 165.402C278.134 159.587 279.781 153.073 279.765 146.455C279.765 124.407 261.889 106.533 239.838 106.533C217.786 106.533 199.91 124.407 199.91 146.455V386.235H226.465V292.938H239.838C293.684 292.95 343.188 263.393 368.716 215.989C375.563 203.383 380.49 189.827 383.334 175.768C392.119 132.672 381.075 87.9088 353.252 53.8417C325.429 19.7747 283.772 0.00781271 239.783 0ZM226.411 146.482C226.4 141.072 229.651 136.188 234.647 134.11C239.643 132.032 245.399 133.169 249.23 136.991C253.06 140.813 254.209 146.566 252.141 151.566C250.072 156.566 245.195 159.826 239.783 159.826H226.411V146.482Z",
    fill: "url(#paint0_linear_2243_621)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M279.711 146.484C279.727 153.101 278.08 159.616 274.92 165.431C267.948 178.372 254.431 186.44 239.729 186.434H226.411V159.828H239.784C244.689 159.798 249.194 157.116 251.559 152.818C252.611 150.873 253.16 148.696 253.156 146.484H279.711Z",
    fill: "url(#paint1_linear_2243_621)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M239.784 239.673H226.411V213.121H239.784C264.288 213.087 286.809 199.647 298.471 178.098C300.095 175.067 301.488 171.918 302.639 168.679C305.161 161.551 306.443 154.045 306.429 146.484H332.957C332.937 157.075 331.106 167.583 327.544 177.556C325.944 182.088 323.989 186.487 321.697 190.711C305.423 220.802 273.996 239.587 239.784 239.673Z",
    fill: "url(#paint2_linear_2243_621)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M386.285 146.484C386.282 156.32 385.294 166.131 383.334 175.77C380.49 189.829 375.563 203.385 368.717 215.99C343.178 263.412 293.65 292.971 239.784 292.94H226.411V266.388H239.784C283.855 266.286 324.35 242.117 345.355 203.378C350.95 193.078 354.983 182.004 357.32 170.519C358.921 162.617 359.728 154.574 359.729 146.511L386.285 146.484Z",
    fill: "url(#paint3_linear_2243_621)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.3091 159.824H62.2061V186.376H93.3091V159.824Z",
    fill: "url(#paint4_linear_2243_621)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.3097 213.121H31.1035V239.673H93.3097V213.121Z",
    fill: "url(#paint5_linear_2243_621)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.3093 266.387H0V292.939H93.3093V266.387Z",
    fill: "url(#paint6_linear_2243_621)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M835.398 173.601C859.436 173.601 878.899 193.847 878.899 218.802C878.899 243.757 859.436 263.975 835.398 263.975C825.249 263.974 815.439 260.324 807.76 253.69V304.521H791.87V218.802L791.923 216.544C793.055 192.613 812.088 173.601 835.398 173.601ZM1125.4 145.019V173.709H1157.88V189.597H1125.4V219.993C1125.4 236.178 1137.79 249.305 1153.01 249.305C1155.42 249.355 1157.83 249.054 1160.15 248.412V264.652C1157.79 265.045 1155.4 265.244 1153.01 265.247C1142.87 265.221 1133.08 261.573 1125.4 254.962C1115.25 246.179 1109.45 233.408 1109.51 219.993V189.597H1098.06V173.709H1109.51V145.019H1125.4ZM559.287 145.1C567.671 145.076 575.808 147.944 582.323 153.22C594.378 162.934 598.977 179.218 593.797 193.824C588.617 208.43 574.786 218.181 559.287 218.152H530.782V264.192H514.893V145.1H559.287ZM632.538 173.601V183.886C640.223 177.263 650.029 173.614 660.176 173.601C662.571 173.625 664.961 173.842 667.322 174.251V190.491C664.998 189.828 662.593 189.491 660.176 189.489C644.935 189.489 632.538 202.562 632.538 218.802V264.138H616.648V173.601H632.538ZM915.47 144.992V181.342C930.982 169.961 952.472 171.569 966.118 185.131C973.5 192.441 977.644 202.405 977.622 212.793V263.975H961.732V212.739C961.576 200.374 951.736 190.31 939.375 189.877C927.015 189.443 916.493 198.791 915.47 211.115V263.84H899.58V144.992H915.47ZM1037.84 174.105C1059.22 174.105 1077.41 189.71 1080.65 210.844C1081.59 216.099 1081.59 221.478 1080.65 226.732V226.841H1011.27C1014.26 239.162 1025.17 247.928 1037.85 248.196C1045.55 248.165 1052.85 244.809 1057.88 238.993L1071.72 247.113C1063.66 257.688 1051.15 263.919 1037.85 263.975C1016.41 263.661 998.312 247.926 995.028 226.732C994.09 221.478 994.09 216.099 995.028 210.844C998.27 189.71 1016.45 174.105 1037.84 174.105ZM727.552 173.574C751.563 173.574 771.053 193.82 771.053 218.775C771.053 243.73 751.59 263.948 727.552 263.948C703.514 263.948 684.024 243.757 684.024 218.775C684.024 193.793 703.514 173.574 727.552 173.574ZM835.398 189.462C820.212 189.462 807.76 202.643 807.76 218.802C807.76 234.96 820.158 248.087 835.398 248.087C850.638 248.087 863.009 234.933 863.009 218.775C863.009 202.616 850.584 189.462 835.398 189.462ZM727.552 189.462C712.312 189.462 699.914 202.616 699.914 218.775C699.914 234.933 712.339 248.06 727.552 248.06C742.765 248.06 755.163 234.933 755.163 218.775C755.163 202.616 742.765 189.462 727.552 189.462ZM1037.84 188.96C1024.89 188.96 1013.75 198.134 1011.27 210.844H1064.41C1061.93 198.134 1050.79 188.96 1037.84 188.96ZM559.26 160.907H530.782V202.183H559.287C564.016 202.176 568.601 200.552 572.28 197.582C579.028 192.054 581.582 182.888 578.664 174.668C575.746 166.448 567.983 160.943 559.26 160.907Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2243_621",
    x1: 35493.8,
    y1: 2771.58,
    x2: 1745.44,
    y2: 39090.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59F1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2243_621",
    x1: -26377.7,
    y1: 7762.26,
    x2: 4778.25,
    y2: -3004.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2243_621",
    x1: -25221.8,
    y1: 12975.2,
    x2: 6639.56,
    y2: 1961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2243_621",
    x1: -24068.7,
    y1: 16998.9,
    x2: 8054.57,
    y2: 5897.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2243_621",
    x1: 8239.96,
    y1: 1488.78,
    x2: 1337.19,
    y2: 1488.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2243_621",
    x1: 21454.1,
    y1: 1539.37,
    x2: 748.451,
    y2: 1539.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2243_621",
    x1: 54940.7,
    y1: 1592.63,
    x2: -7178.88,
    y2: 1592.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPe);
export default __webpack_public_path__ + "static/media/pe.fe781f00f5264657af82cf6843291ba2.svg";
export { ForwardRef as ReactComponent };